import { observer } from 'mobx-react-lite'
import React from 'react'
import { Switch, Typography } from 'shared/ui'
import { GreetingAudioBlockEditContent } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/blocks/GreetingAudioBlock'
import styles from './styles.module.scss'
import { type SendToVoicemailStore } from '../../store/SendToVoicemailStore'

type IActionEditContentProps = {
  store: SendToVoicemailStore
}
export const SendToVoicemailActionEditContent = observer(({ store }: IActionEditContentProps) => {
  const { greetingAudioBlockStore, isGetVoicemailViaEmail, setGetVoicemailViaEmail, step } = store

  return (
    <div className={styles.wrap}>
      <GreetingAudioBlockEditContent
        labelText={'Greeting message'}
        store={greetingAudioBlockStore}
      />
      {step.args?.audioUrl && (
        <div className={styles.switchField}>
          <div className={styles.left}>
            <Typography ariaLabel={'title'} variant={'body-md-medium'}>
              Get Voicemail Via Email
            </Typography>
            <Typography ariaLabel={'subtitle'} variant={'body-md-regular'} color={'tertiary'}>
              Get a recording of your voicemails by email
            </Typography>
          </div>
          <div className={styles.switch}>
            <Switch
              value={isGetVoicemailViaEmail}
              onChange={setGetVoicemailViaEmail}
              size={'middle'}
            />
          </div>
        </div>
      )}
    </div>
  )
})
